import React, { useEffect, useState } from "react";
import { FAIcon } from "../Icon";
import "./ScrollToTop.scss";

interface ScrollToTopProps {}

const ScrollToTop: React.FC<ScrollToTopProps> = (props: ScrollToTopProps) => {
  const componentName = "scroll-to-top";
  const [isVisable, setIsVisable] = useState(false);

  const toggleVisibility = () => {
    if (window.pageYOffset > 100) {
      setIsVisable(true);
    } else {
      setIsVisable(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  return (
    <>
      {isVisable ? (
        <button className={componentName} onClick={scrollToTop}>
          <FAIcon icon={["fas", "angle-up"]} />
        </button>
      ) : null}
    </>
  );
};

export default ScrollToTop;
